import { IAvailableArchitectureType } from '../../models/MigrateModels';
import { IStoreAction } from '../StoreHelper';

export enum MigrateActionTypes {
  SET_ARCHITECTURES_START = 'SET_ARCHITECTURES_START',
  SET_ARCHITECTURES_SUCCESS = 'SET_ARCHITECTURES_SUCCESS',
  SET_ARCHITECTURES_ERROR = 'SET_ARCHITECTURES_ERROR',
}

export type MigrateActionPayload = string | IAvailableArchitectureType[] | Error | null | undefined;

export type MigrateAction = IStoreAction<MigrateActionTypes, MigrateActionPayload>;

export class MigrateActions {
  public static setArchitecturesStart(
    data:IAvailableArchitectureType[] | undefined,
  ): MigrateAction {
    return {
      type: MigrateActionTypes.SET_ARCHITECTURES_START,
      data,
    };
  }
  public static setArchitecturesSuccess(data: IAvailableArchitectureType[] | undefined): MigrateAction {
    return {
      type: MigrateActionTypes.SET_ARCHITECTURES_SUCCESS,
      data,
    };
  }
  public static setArchitecturesError(error: Error): MigrateAction {
    return {
      type: MigrateActionTypes.SET_ARCHITECTURES_ERROR,
      data: error,
    };
  }
}
